module.exports = __webpack_public_path__ + "img/user8-128x128.cc1516d8.jpg";